import React from "react";

import DonutChart from "../../components/common/charts/Donut-chart";
import Schedular from "./Schedular";
import Tabs from "./Tabs";
import DashboardContent from "./Dashboard-content";

const Dashboard = () => {
  const tabsData = [
    {
      label: "7 days",
      content: <DashboardContent />,
    },
    {
      label: "30 days",
      content: <DashboardContent />,
    },
    {
      label: "90 days",
      content: <DashboardContent />,
    },
  ];

  return (
    <div
      className="flex flex-1"
      style={{ backgroundImage: `url(/images/overview-image.png)` }}
    >
      {/* <!-- Sidebar --> */}
      <aside className="w-1/5 bg-white p-4 mt-10 mr-2 ml-4 rounded-xl">
        <div className="mb-4">
          <Schedular></Schedular>
        </div>
      </aside>

      <main className="flex-1 p-6 bg-white mt-10 ml-2 mr-4 rounded-xl">
        <div className="w-full">
          <Tabs tabs={tabsData} />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
